import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AdministradorService } from '../../../../services/administrador.service';
import { Catalogo } from 'src/app/models/catalogos.interface';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-diagnostico',
  templateUrl: './diagnostico.component.html',
  styleUrls: ['./diagnostico.component.scss'],
  providers: [MessageService]
})
export class DiagnosticoComponent {
  catalogoForm: FormGroup;
 
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private administradorService: AdministradorService
  ) {    
    this.catalogoForm = this.crearFormulario();
  }


  onSubmit() {
    if (this.catalogoForm.valid) {
   //   console.log('Formulario enviado:', this.catalogoForm.value);
      const catalogo: Catalogo = this.catalogoForm.value;

      this.administradorService
      .setDiagnostico(catalogo)
      .subscribe({
        next: (resp)=>{

          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: resp.mensaje
          });
          this.resetForm();

        },
        error: (err: HttpErrorResponse)=> { 
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error.message
          });
          this.markFormGroupTouched(this.catalogoForm);
        }
      })
      
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      this.markFormGroupTouched(this.catalogoForm);
    }
  }
  crearFormulario(): FormGroup {
    return this.fb.group({    
      descripcion: ['', [Validators.required, Validators.minLength(3)]],
    });
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  get f() {
    return this.catalogoForm.controls;
  }

  resetForm(): void {
    this.catalogoForm.reset();
  }
}
